// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#checkOrganizerSetupModal[data-v-296b0ab6] .modal__dialog {color: var(--color-slate-two, #546e7a);}\n@media (min-width: 992px) {\n#checkOrganizerSetupModal[data-v-296b0ab6] .modal__body {height: auto; padding: 24px 32px;}\n}\n", ""]);
// Exports
module.exports = exports;
